import { Disclosure } from '@headlessui/react';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';

function DropCourseFAQTab() {
  return (
    <div className={'flex flex-col gap-xl p-4'}>
      <div>
        <Disclosure as={'div'} defaultOpen={true}>
          {({ open }) => (
            <>
              <Disclosure.Button className='flex w-full justify-between p-2 py-3'>
                <Typography
                  type='title'
                  size='h4'
                  className='flex items-center gap-4'
                >
                  Quando trocar de curso?
                </Typography>
                <Icon
                  type='material'
                  Icon={'chevron_right'}
                  className={`text-mono-color-black ${open ? 'rotate-90 transform' : ''}`}
                />
              </Disclosure.Button>

              <Disclosure.Panel className='flex flex-col gap-lg px-2 pb-3'>
                <Typography>
                  É importante lembrar que a mudança de curso é uma decisão
                  significativa e deve ser considerada com cuidado. Aqui estão
                  algumas orientações sobre quando considerar essa mudança:
                </Typography>
                <Typography>
                  <b>1. Estratégias de Recuperação:</b> Antes de decidir mudar
                  de curso, avalie se há maneiras de colocar o conteúdo em dia
                  no curso atual. Use ferramentas como a identificação dos
                  assuntos mais importantes através das incidências das aulas e
                  aulas resumidas com duração menor para otimizar seu tempo de
                  estudo. Isso pode ajudar a manter o progresso nas semanas já
                  realizadas.
                </Typography>
                <Typography>
                  <b>2. Autoavaliação:</b> Faça uma autoavaliação honesta sobre
                  sua capacidade de se organizar e manter o ritmo no curso
                  atual. Se você acredita que pode se adaptar e recuperar o
                  atraso, considere dar mais uma chance antes de mudar.
                </Typography>
                <Typography>
                  <b>3. Curso mais próximo:</b> Se, apesar dos esforços, você
                  ainda se sentir sobrecarregado e desorganizado no curso atual,
                  considere ingressar na turma mais próxima. Isso lhe dará a
                  oportunidade de começar com um novo começo, aproveitando as
                  lições aprendidas com a experiência anterior.{' '}
                </Typography>
                <Typography>
                  <b>4. Faça uma reflexão cautelosa:</b> lembre-se de que cada
                  mudança de curso representa um novo começo e pode afetar seu
                  cronograma de estudo. Portanto, tome essa decisão com cuidado
                  e somente quando necessário.
                </Typography>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure as={'div'}>
          {({ open }) => (
            <>
              <Disclosure.Button className='flex w-full justify-between p-2 py-3'>
                <Typography
                  type='title'
                  size='h4'
                  className='flex items-center gap-4'
                >
                  O que são os cursos regulares?
                </Typography>
                <Icon
                  type='material'
                  Icon={'chevron_right'}
                  className={`text-mono-color-black ${open ? 'rotate-90 transform' : ''}`}
                />
              </Disclosure.Button>

              <Disclosure.Panel className='px-2 pb-3'>
                <Typography>
                  Os cursos regulares oferecidos pelo Aprova Total englobam
                  tanto os cursos extensivos quanto os intensivos, sendo uma
                  parte fundamental da preparação para o Enem e vestibulares.
                  Esses cursos são estruturados de forma a cobrir toda a base
                  curricular do ensino médio, seguindo rigorosamente os padrões
                  e diretrizes do currículo nacional. Isso significa que os
                  alunos têm a oportunidade de revisar e consolidar os
                  conhecimentos adquiridos ao longo de todo o ensino médio, ao
                  mesmo tempo em que se aprofundam em tópicos específicos que
                  são particularmente relevantes para as provas do Enem e
                  vestibulares.
                </Typography>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure as={'div'}>
          {({ open }) => (
            <>
              <Disclosure.Button className='flex w-full justify-between p-2 py-3'>
                <Typography
                  type='title'
                  size='h4'
                  className='flex items-center gap-4'
                >
                  Qual a diferença entre os cursos?
                </Typography>
                <Icon
                  type='material'
                  Icon={'chevron_right'}
                  className={`text-mono-color-black ${open ? 'rotate-90 transform' : ''}`}
                />
              </Disclosure.Button>

              <Disclosure.Panel className='px-2 pb-3'>
                <Typography>
                  Os cursos extensivos são programas mais longos, que se
                  estendem por várias semanas, proporcionando uma abordagem
                  gradual e abrangente dos conteúdos do ensino médio. Por outro
                  lado, os cursos intensivos são caracterizados por sua duração
                  mais curta e foco em concentrar uma maior quantidade de
                  conteúdos em um período mais curto. Independentemente da
                  escolha entre extensivo ou intensivo, esses cursos regulares
                  têm como objetivo principal oferecer uma sólida base
                  curricular, abordando os tópicos essenciais exigidos nos
                  exames do Enem e vestibulares.
                </Typography>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
      <div className='flex flex-col gap-md'>
        <Typography>
          Tem certeza que deseja abandonar este curso regular?
        </Typography>
        <Typography>Essa ação não poderá ser desfeita.</Typography>
      </div>
    </div>
  );
}
export { DropCourseFAQTab };
